import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const PDILogsViewModule = new Module({
  id: 'PDI-LOGS:VIEW:PDI-LOGS',
  name: 'PDI Logs',
  path: 'view-pdi-logs',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/PDILogs/View'))
  ),
  actions: {
    viewLogReport: {
      id: 'PDI-LOGS:VIEW:PDI-LOG-REPORT',
      name: 'view-pdi-log-report',
      label: 'Log Report'
    },
    printPdiSticker: {
      id: 'PDI-LOGS:VIEW:PRINT-STICKER',
      name: 'print-pdi-sticker',
      label: 'Print Sticker'
    },
    printStickerFromQr: {
      id: 'PDI-LOGS:VIEW:PRINT-STICKER-FROM-QR',
      name: 'print-sticker-from-qr',
      label: 'Print Sticker From QR'
    }
  }
});

const PDILogsModule = [PDILogsViewModule];

export default new ModuleBundle('PDILogs', PDILogsModule);
